<template>
  <v-col cols="12" md="3">
    <v-card :loading="loading" class="mx-auto d-flex flex-column" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text class="text-h6 font-weight-bold"> Matrículas por Tipo de Ensino </v-card-text>

      <v-card-text class="font-weight-bold flex-grow-1 overflow-y-auto">
        <div class="d-flex justify-space-between w-100 mb-2">
          <span>
            <v-icon size="12" color="blue" class="mr-2"> mdi-circle </v-icon>
            Creche
          </span>
          <span>{{ quantitativos.creche ?? 0 }}</span>
        </div>

        <div class="d-flex justify-space-between w-100 mb-2">
          <span>
            <v-icon size="12" color="purple" class="mr-2"> mdi-circle </v-icon>
            Pré Escola
          </span>
          <span>{{ quantitativos.pre ?? 0 }}</span>
        </div>

        <div class="d-flex justify-space-between w-100">
          <span>
            <v-icon size="12" color="pink" class="mr-2"> mdi-circle </v-icon>
            Unificada (0 a 5 anos)
          </span>
          <span>{{ quantitativos.unificada ?? 0 }}</span>
        </div>

        <div class="d-flex justify-space-between w-100 mb-2">
          <span>
            <v-icon size="12" color="green" class="mr-2"> mdi-circle </v-icon>
            Ensino Fundamental
          </span>
          <span>{{ quantitativos.fundamental ?? 0 }}</span>
        </div>

        <div class="d-flex justify-space-between w-100">
          <span>
            <v-icon size="12" color="orange" class="mr-2"> mdi-circle </v-icon>
            EJA
          </span>
          <span>{{ quantitativos.eja ?? 0 }}</span>
        </div>

        <div class="d-flex justify-space-between w-100">
          <span>
            <v-icon size="12" color="pink" class="mr-2"> mdi-circle </v-icon>
            Educação Especial
          </span>
          <span>{{ quantitativos.especial ?? 0 }}</span>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "MatriculasPorUnidade",
  props: {
    franquiaId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      quantitativos: {
        creche: 0,
        eja: 0,
        especial: 0,
        fundamental: 0,
        pre: 0,
        unificada: 0,
      },
    };
  },
  methods: {
    async fetchQtd(franquia) {
      this.loading = true;
      try {
        this.quantitativos = await this.$services.matriculasService.quantidadeMatriculasPorEnsino(
          franquia
        );
      } catch (error) {
        console.error("Erro ao buscar matrículas:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.fetchQtd(value);
    },
  },
};
</script>
